import { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../styles.css";
import CryptoAES from "crypto-js/aes";
import CryptoJS from "crypto-js";
import { fabric } from "fabric";

function DesignPopup(props) {
  const { title, display, _id } = props;

  const [canvas, setCanvas] = useState("");
  const [accountType, setAccountType] = useState("client"),
    askDeletionConfirmation = () => {
      let myVal = window.confirm("Do you really want to delete this design?");
      console.log(myVal);
    },
    hidePopup = () => {
      document.getElementsByClassName("DesignPopup")[0].style.display = "none";
      document.body.style.overflow = "auto";
    };
  let token = localStorage?.getItem("skiUserToken");
  document.documentElement.onclick = (e) => {
    if (e.target.id === "PopupTransparentBg") {
      if (canvas !== "") canvas.dispose();
      setCanvas("");
      hidePopup();
    }
  };

  const editClicked = () => {
    // var key = CryptoJS.enc.Utf8.parse("b75524255a7f54d2726a951bb39204df");
    // var iv = CryptoJS.enc.Utf8.parse("1583288699248111");
    // var encryptedCP = CryptoJS.AES.encrypt(token, key, {
    //   iv: iv,
    // });
    // let enc_token = CryptoJS.HmacSHA1.encrypt(
    //   "HII",
    //   "secret key 123"
    // ).toString();
    // console.log(enc_token);

    window.location.href = `http://localhost:3001?id=${_id}&AUTH_TOKEN=${token}`;
  };

  useEffect(() => {
    if (token) {
      let decodedToken = props.jwt_decode(token);
      setAccountType(decodedToken.AccountType);
    }
  }, [token, props]);
  useEffect(() => {}, []);
  return (
    <div className="DesignPopup" style={{ display }}>
      <div className="PopupTransparentBg" id="PopupTransparentBg"></div>
      <div className="PopupContent">
        <div className="PopupHeader">
          <p>{title}</p>
          <button onClick={() => hidePopup()}>Back</button>
        </div>
        <div
          className="slideshowHolder"
          // style={{ height: "60vh", width: "100%" }}
        >
          <Carousel>
            <div>
              <img
                src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
                alt="some img"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1608231387042-66d1773070a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
                alt="some img"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1603191659812-ee978eeeef76?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
                alt="some img"
              />
            </div>
          </Carousel>
        </div>
        <div className="DesignOptions">
          {accountType === "client" ? (
            <button className="download-design">Download</button>
          ) : (
            <button
              className="del-design"
              onClick={() => askDeletionConfirmation()}
            >
              Delete
            </button>
          )}
          <button onClick={editClicked}>Edit</button>
        </div>
      </div>
    </div>
  );
}

export default DesignPopup;
